import * as React from "react";
import { cn } from "../../lib/utils";

export const Button = React.forwardRef(
  ({ className, variant = "default", size = "default", ...props }, ref) => {
    const variants = {
      default:     "bg-primary text-primary-foreground hover:bg-primary/90 shadow",
      destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
      outline:     "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
      secondary:   "bg-secondary text-secondary-foreground hover:bg-secondary/80",
      ghost:       "hover:bg-accent hover:text-accent-foreground",
      link:        "text-primary underline-offset-4 hover:underline",
      success:     "bg-green-700 text-white hover:bg-green-800 shadow",
    };
    const sizes = {
      default: "h-9 px-4 py-2",
      sm:      "h-7 rounded-md px-3 text-xs",
      lg:      "h-10 rounded-md px-8",
      icon:    "h-9 w-9",
    };
    return (
      <button
        ref={ref}
        className={cn(
          "inline-flex items-center justify-center rounded-md text-sm font-medium",
          "ring-offset-background transition-colors focus-visible:outline-none",
          "focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
          "disabled:pointer-events-none disabled:opacity-50",
          variants[variant],
          sizes[size],
          className
        )}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";
